<template>
    <div class="video-wrapper">
        <div class="video-container">
            <iframe
                src="https://player.arvancloud.ir/index.html?config=https://atigh.arvanvod.ir/lGpeEBPVX3/kVXPgDBdjN/origin_config.json&skin=shaka"
                style="border: 0 #ffffff none"
                name="full HD.mp4"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen="true"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
            />
        </div>
    </div>
</template>

<style scoped lang="scss">
.video-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .video-container {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100%;
        padding-top: 35.25%;
        max-width: $app-container-max-width;
        border-radius: 12px;
        @include mobile-only {
            padding-top: 56.25%;
        }
        iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;
        }
    }
}
</style>
